import { DisplayBreakpoint } from "@/@types/display";

/**
 *
 * tailwindcssで使ってるDisplayBreakpointに変換する
 *
 * https://tailwindcss.com/docs/responsive-design
 * @param displayWidth
 */
export function convertDisplayBreakpoint(displayWidth: number): DisplayBreakpoint {
  if (displayWidth >= 640) {
    return "pc";
  }
  return "mobile";
}
